import {
    onRequest,
    onAdsSuccess,
    onNoAds,
    onScriptError,
    onLoadError,
    onLoadSuccess
} from "OK/banners/BannerPlaceListeners";
import {BannerViewJs} from "OK/banners/bannerNew/BannerViewJs";
import {ReqId} from "OK/banners/bannerNew/transport/BannerTransportJs";
import {createLog, isDebug} from "OK/banners/bannerNew/utils/BannerCommon";

const log = createLog('BannerPlaceListenersProxyJs');

let instance: BannerPlaceListenersProxyJs | null = null;

export class BannerPlaceListenersProxyJs {
    hooksByBannerPlaces: { [key: string]: any } = {};

    constructor() {
        this.hooksByBannerPlaces = {}
    }

    static getInstance() {
        if (instance === null) {
            instance = new BannerPlaceListenersProxyJs();
        }
        return instance;
    }

    logState(msg: string, view: BannerViewJs) {
        if (isDebug) {
            log(msg + ', place: \'' + view.place
                + '\', slot: ' + view.getSlot()
                + ', keys: ' + Object.keys(this.hooksByBannerPlaces));
        }
    }

    addBannerView(view: BannerViewJs) {
        const place = view.getPlace();
        if (place) {
            this.hooksByBannerPlaces[place] = view.getContainer();
        }
        this.logState('added view', view);
    }

    removeBannerView(view: BannerViewJs) {
        const place = view.getPlace();
        if (place) {
            delete this.hooksByBannerPlaces[place];
        }
        this.logState('removed view', view);
    }

    getResponseData(reqId: ReqId) {
        const place = reqId.bannerPlace;
        const hookEl = this.hooksByBannerPlaces[place];
        return {
            transport: reqId.transport,
            place: place,
            slot: reqId.slot,
            el: hookEl
        }
    }

    onRequest(reqId: ReqId) {
        onRequest(this.getResponseData(reqId));
    }

    onAdsSuccess(reqId: ReqId) {
        onAdsSuccess(this.getResponseData(reqId));
    }

    onNoAds(reqId: ReqId) {
        onNoAds(this.getResponseData(reqId));
    }

    onScriptError(reqId: ReqId) {
        onScriptError(this.getResponseData(reqId));
    }

    onLoadSuccess(reqId: ReqId) {
        onLoadSuccess(this.getResponseData(reqId));
    }

    onLoadError(reqId: ReqId) {
        onLoadError(this.getResponseData(reqId));
    }
}